import {Component, OnInit} from "@angular/core";
import {UserService} from "../../services/users.service";
import {Router} from "@angular/router";
import {Auth2Service} from "../../../../services/auth2.service";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-canceled-consultant-checkout',
  templateUrl: './canceled-consultant-checkout.component.html',
  styleUrls: ['./canceled-consultant-checkout.component.scss'],
  standalone: false
})
export class CanceledConsultantCheckoutComponent implements OnInit {
  breadCrumbs = [
    { iconClass: 'bi-house', path: 'app/users/dashboard'},
    { label: 'Login', path: 'app/login'},
    { label: 'Canceled Consultant Checkout'}
  ];

  showMessages = false;
  messages: any[] = [];
  username: string = '';

  pageName = 'Canceled Consultant Checkout';

  constructor(private userService: UserService,
              private routerChild: Router,
              private auth2ServiceChild: Auth2Service,
              private titleService: Title) {
    this.titleService.setTitle("Scalanthropy Canceled Consultant Checkout");
  }

  ngOnInit() {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
    const counterFn = () => {
      this.routerChild.navigateByUrl('app/login');
    }
    setTimeout(counterFn, 10000);
  }

  onGoToLogin(): void {
    this.routerChild.navigateByUrl('app/login');
  }
}
